<div class="display-flex flex-column ticket-preview-modal-container" cdkDrag cdkDragRootElement=".cdk-overlay-pane">
  <div mat-dialog-title class="display-flex modal-header" cdkDragHandle *ngIf="!isLoading; else skeleton.skeletonTitle">
    <div class="w-100 display-flex align-items-center justify-content-space-between">
      <div class="w-100 display-flex align-items-center justify-content-space-between">
        <ng-container [ngTemplateOutlet]="ticketHeaderTemplate"></ng-container>
      </div>
    </div>
  </div>

  <mat-dialog-content>
    <form *ngIf="form" [formGroup]="form" (ngSubmit)="save()">
      <div class="display-flex justify-content-space-between overflow-auto">
        <ng-container *ngIf="!isLoading; else skeleton.skeletonContent">
          <div class="display-flex flex-column grid-gap-12 details-container">
            <div class="display-flex grid-gap-16">
              <div class="display-flex w-50">
                <app-radio-button-dropdown
                  class="w-100"
                  [items]="properties"
                  [allowSearch]="properties?.length > 7"
                  [attrDisable]="!properties?.length || form.get('id')?.value"
                  [label]="'Property'"
                  formControlName="propertyId"
                  [allowClear]="true"
                  [listLoading]="selectPropertiesLoading$ | async"
                  [attrPlaceholder]="(selectPropertiesLoading$ | async) ? 'Loading properties…' : 'Select a property'"
                  [labelRequired]="true"
                  [showValidationError]="formSubmitted && form.get('propertyId')?.invalid"
                  attrAppendTo="body"></app-radio-button-dropdown>
              </div>

              <div class="display-flex w-50">
                <app-radio-button-dropdown
                  class="w-100"
                  [items]="units$ | async"
                  [allowSearch]="(units$ | async)?.length > 7"
                  [attrDisable]="!(units$ | async)?.length || !form.get('propertyId')?.value"
                  [label]="'Units'"
                  formControlName="bulkUnitIds"
                  [allowClear]="false"
                  [allowSelectAll]="true"
                  [multiSelect]="true"
                  [listLoading]="unitListLoading$ | async"
                  [attrPlaceholder]="(unitListLoading$ | async) ? 'Loading units…' : 'Select units'"
                  [showValidationError]="formSubmitted && form.get('propertyId')?.value"
                  attrAppendTo="body"></app-radio-button-dropdown>
              </div>
            </div>

            <div>
              <div class="display-flex w-100">
                <app-radio-button-dropdown
                  class="w-100"
                  [items]="dynamicTicketTypesOpt"
                  [label]="'Type'"
                  formControlName="dynamicTicketType"
                  [allowClear]="true"
                  [listLoading]="isTicketTypesLoading"
                  [attrPlaceholder]="isTicketTypesLoading ? 'Loading types' : 'Select type'"
                  [labelRequired]="true"
                  [showValidationError]="formSubmitted && form.get('dynamicTicketType')?.invalid"
                  attrAppendTo="body"></app-radio-button-dropdown>
              </div>

              <div class="message" *ngIf="isWorkOrder && form.get('propertyId')?.value">
                <app-bulk-ticket-type-message
                  [pmsType]="pmsType"
                  [categoryId]="form.get('ticketCategoryId')?.value || defaultCategoryId"
                  [topicId]="form.get('ticketTopicId')?.value || defaultTopicId"
                  [origin]="form.get('origin')?.value ?? defaultOrigin"></app-bulk-ticket-type-message>
              </div>
            </div>

            <div class="display-flex grid-gap-16" *ngIf="isWorkOrder">
              <app-radio-button-dropdown
                class="flex-1"
                [items]="originOptions"
                [allowSearch]="originOptions?.length > 7"
                [label]="'Origin'"
                formControlName="origin"
                [allowClear]="true"
                [labelRequired]="true"
                [attrPlaceholder]="!form.get('propertyId')?.value ? 'Select a property' : 'Default origin'"
                [attrDisable]="!form.get('propertyId')?.value"
                attrAppendTo="body"></app-radio-button-dropdown>
            </div>

            <div class="display-flex grid-gap-16" *ngIf="isWorkOrder">
              <app-radio-button-dropdown
                class="flex-1"
                [label]="'Category'"
                [items]="categories"
                formControlName="ticketCategoryId"
                [allowClear]="true"
                [labelRequired]="true"
                [allowSearch]="categories?.length > 7"
                [attrPlaceholder]="!form.get('propertyId')?.value ? 'Select a property' : 'Default category'"
                [attrDisable]="!form.get('propertyId')?.value"
                [listLoading]="isCategoriesLoading"
                [showValidationError]="formSubmitted"></app-radio-button-dropdown>
              <app-radio-button-dropdown
                class="flex-1"
                [label]="'Topic'"
                [items]="topics"
                formControlName="ticketTopicId"
                [allowClear]="true"
                [labelRequired]="true"
                [allowSearch]="topics?.length > 7"
                [attrPlaceholder]="!form.get('propertyId')?.value ? 'Select a property' : 'Default topic'"
                [attrDisable]="!form.get('propertyId')?.value"
                [listLoading]="isCategoriesLoading"
                [showValidationError]="formSubmitted"></app-radio-button-dropdown>
            </div>

            <div class="form-row-priority-repeats grid-gap-16">
              <app-radio-button-dropdown
                [autoSortList]="false"
                [items]="priorityTypeList"
                [label]="'Priority'"
                [containerWidthCss]="'w-123'"
                formControlName="priority"
                [allowClear]="false"
                [allowSearch]="false"
                [attrPlaceholder]="'priority'"
                [labelRequired]="true"></app-radio-button-dropdown>

              <app-radio-button-dropdown
                [autoSortList]="false"
                [items]="recurrenceOptions"
                [label]="'Repeats'"
                formControlName="recurringPeriod"
                [allowClear]="true"
                [allowSearch]="false"
                [attrPlaceholder]="'Repeats'"
                appendTo="body"
                class="wide-dropdown-350"
                [labelRequired]="data.isRepeating"></app-radio-button-dropdown>

              <app-date-dropdown
                formControlName="repeatUntil"
                [buttonCss]="'date-dropdown-button-small w-100'"
                [containerCss]="'display-flex flex-column'"
                [label]="'Until'"
                [labelCss]="'body-small-bold nowrap'"
                [attrPlaceholder]="'the end of time'"></app-date-dropdown>
            </div>

            <div>
              <div class="grid-gap-16 form-row-due-date">
                <app-date-dropdown
                  formControlName="dueDate"
                  [buttonCss]="'date-dropdown-button-small w-100'"
                  [containerCss]="'display-flex flex-column'"
                  [label]="'Due'"
                  [labelCss]="'body-small-bold nowrap'"
                  [labelRequired]="true"
                  [attrPlaceholder]="'select date'"></app-date-dropdown>

                <div>
                  <div class="display-flex grid-gap-16">
                    <app-user-select-dropdown
                      [containerCss]="'display-flex flex-column'"
                      class="assignee-dropdown"
                      [allowClear]="false"
                      [labelRequired]="false"
                      [label]="'Assignee'"
                      [labelCss]="'nowrap body-small-bold'"
                      formControlName="assigneeId"
                      [users]="users$ | async"
                      [attrDisable]="!form.get('propertyId')?.value"
                      [labelAsFullName]="true"
                      [attrPlaceholder]="(propertyUserListLoading$ | async) ? 'Loading assignees…' : 'Select assignee'"
                      [listLoading]="propertyUserListLoading$ | async"></app-user-select-dropdown>

                    <app-radio-button-dropdown
                      [displaySkeleton]="false"
                      class="notify-dropdown"
                      [containerCss]="'w-100'"
                      [items]="notifyOptions"
                      [label]="'Notify on'"
                      formControlName="notifyOnMode"
                      [allowClear]="false"
                      [allowSearch]="notifyOptions?.length > 7"
                      [autoSortList]="false"
                      [showValidationError]="false"
                      [labelRequired]="false"
                      attrAppendTo="body"></app-radio-button-dropdown>
                  </div>

                  <div class="mt-4">
                    <app-notify-message
                      [showCreateMessage]="false"
                      [assigneeName]="assigneeName$ | async"
                      [notifyAssignee]="form.get('notifyOnMode')?.value === CustomNotifyId"
                      [customNotifyOnMode]="
                        form.get('customNotifyOnMode')?.value ?? DynamicTicketTypeNotifyAssigneeMode.OnDueDate
                      "
                      [customNotifyOn]="form.get('customNotifyOn')?.value"
                      [remindOn]="form.get('remindOn')?.value"
                      [thenRemindOn]="form.get('thenRemindOn')?.value"
                      [until]="form.get('until')?.value"
                      (onOpenDialog)="openCustomNotificationsDialog()"></app-notify-message>
                  </div>
                </div>
              </div>
            </div>

            <app-input
              class="w-100"
              [labelCss]="'body-small-bold nowrap'"
              [attrLabel]="'Title'"
              [contentCss]="'display-flex flex-column fill body-small'"
              formControlName="title"
              [attrPlaceholder]="data?.isNew ? 'A mind-blowing ticket title...' : 'A next-level ticket title...'"
              [labelRequired]="true"
              [showValidationError]="formSubmitted"
              [displayCounter]="true"
              [maxCounter]="255"></app-input>

            <app-input-area
              class="w-100"
              [label]="'Description'"
              [inputCss]="'hp-92'"
              [labelCss]="'body-small-bold nowrap'"
              [containerCss]="'fill body-small'"
              formControlName="description"
              [attrPlaceholder]="'A next-level ticket title...'"
              [showValidationError]="formSubmitted"
              [displayCounter]="true"
              [maxCounter]="1000"></app-input-area>

            <div class="display-flex grid-gap-16">
              <app-radio-button-dropdown
                class="flex-1"
                [autoSortList]="false"
                [items]="appointmentTypeOptions"
                formControlName="appointmentType"
                [displayLabelAsValue]="true"
                [allowClear]="false"
                [allowSearch]="false"
                [label]="'Entry/Appointment'"></app-radio-button-dropdown>
            </div>
            <app-input-area
              class="w-100"
              [label]="'Access notes'"
              formControlName="accessNotes"
              [inputCss]="'hp-92'"
              [labelCss]="'body-small-bold nowrap'"
              [containerCss]="'fill body-small'"
              [displayCounter]="true"
              [maxCounter]="1000"></app-input-area>
          </div>
        </ng-container>
      </div>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions class="justify-content-space-between" *ngIf="!isLoading; else skeleton.skeletonActions">
    <button
      type="button"
      mat-stroked-button
      color="warn"
      class="modal-button modal-button-cancel-width"
      (click)="cancel()">
      Cancel
    </button>
    <div class="display-flex grid-gap-8">
      <button
        type="button"
        mat-raised-button
        color="primary"
        class="modal-button modal-button-save-width"
        [class.save]="!data?.isNew"
        (click)="onSubmit()"
        [disabled]="updateInProgress$ | async">
        <div class="display-flex justify-content-center align-items-center grid-gap-4">
          {{ data.isNew ? 'Create' : 'Save changes' }}
          <mat-spinner *ngIf="updateInProgress$ | async" color="accent" diameter="20"></mat-spinner>
        </div>
      </button>
    </div>
  </mat-dialog-actions>
</div>

<ng-template #ticketHeaderTemplate>
  <div class="subtitle">
    {{ data?.isNew ? 'Add' : 'Edit' }} {{ data?.isRepeating ? 'Repeating' : 'Bulk' }} Service Task
  </div>
</ng-template>

<app-skeleton-modals #skeleton></app-skeleton-modals>
